import type {} from '@angular/localize/init';
import type { TranslationConfig } from '@bcf-v2/routes-statics/common/app/i18n-cache';
import { appRoutesI18nCache } from '../i18n-cache';

export function betOnActionRouteI18n(config?: TranslationConfig): string {
  if (config?.translateForLang && globalThis.$localizeForLang) {
    return globalThis.$localizeForLang`:url-segment@@betgenius-bet-on-action-url-segment:bet-on-action`;
  }
  return (appRoutesI18nCache['bet-on-action'] ??=
    $localize`:url-segment@@betgenius-bet-on-action-url-segment:bet-on-action`);
}
